import { render, staticRenderFns } from "./KeywordSummary.vue?vue&type=template&id=311cfe89&"
import script from "./KeywordSummary.vue?vue&type=script&lang=js&"
export * from "./KeywordSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports